import React, { Fragment } from 'react';
import IntlMessages from 'util/IntlMessages';
import ProjectDetailRow from '../projectDetailRow';

const ProjectDetailTable = ({ displayData }) => {
    if (displayData) {
        return (
            <table className="default-table table table-sm table-responsive-sm table-hover">
                <tbody>
                    <ProjectDetailRow label={<IntlMessages id="project.projectDescription" />} description={displayData?.description} />
                    <ProjectDetailRow label={<IntlMessages id="project.projectWeight" />} description={displayData?.weight} />
                    <ProjectDetailRow label={<IntlMessages id="label.startDate" />} description={displayData?.startDate} />
                    <ProjectDetailRow label={<IntlMessages id="label.endDate" />} description={displayData?.endDate} />
                    <ProjectDetailRow label={<IntlMessages id="project.projectBudget" />} description={displayData?.budget} />
                    <ProjectDetailRow label={<IntlMessages id="project.projectBusinessValueIndicator" />} description={displayData?.businessValue} />
                </tbody>
            </table>
        );
    } else {
        return <Fragment></Fragment>;
    }
};

export default ProjectDetailTable;


// WEBPACK FOOTER //
// ./components/Agile/project/projectDetail/projectDetailTable/index.js